import { httpGet, httpPost } from 'shared/services/httpService';
import appSettings from 'shared/settings/appSettings';
import {
    FatigueAssessmentForm,
    FatigueAssessmentDetailsModel,
    SubmitAssessmentModel,
    SubmitOnBehalfModel,
    DashboardQueryModel,
    FatigueAssessmentNote,
    FatigueAssessmentAddNoteModel,
    SubmitActionModel,
    FatigueAssessmentAssign,
    FatigueAssessmentAssignResult,
    SubmitAssessmentModelBase,
} from 'shared/models/api/models';

const fatigueAssessmentUriPath = new URL('/api/fatigue', appSettings.api.portalApi);
const fatigueAssessmentDetails = `${fatigueAssessmentUriPath}/details`;
const fatigueAssessmentSubmitFa = `${fatigueAssessmentUriPath}/fatigueassessment`;
const fatigueAssessmentSubmitOnBehalf = `${fatigueAssessmentUriPath}/onbehalf`;
const fatigueAssessmentsUri = `${fatigueAssessmentUriPath}/current-user/actionable`;
const dashboardFatigueAssessmentsUri = `${fatigueAssessmentUriPath}/dashboard`;
const fatigueAssessmentsAddNoteUri = `${fatigueAssessmentUriPath}/addnote`;
const fatigueAssessmentSaveActionUri = `${fatigueAssessmentUriPath}/action`;
const fatigueAssessmentAssignUri = `${fatigueAssessmentUriPath}/assignassessments`;

export const getFatigueAssessment = async (id: number) => {
    return await httpGet<FatigueAssessmentForm>(`${fatigueAssessmentUriPath}/${id}`)
        .catch(e => { console.log(e); return {} as FatigueAssessmentForm });
};

export const getFatigueAssessmentDetails = async (id: number) => {
    return await httpGet<FatigueAssessmentDetailsModel>(`${fatigueAssessmentDetails}/${id}`)
        .catch(e => { console.log(e); return {} as FatigueAssessmentDetailsModel });
};

export const getFatigueAssessments = async () => {
    const myForm = await httpGet<FatigueAssessmentForm[]>(fatigueAssessmentsUri.toString())
        .catch((e) => {
            console.log(e);
        }) as FatigueAssessmentForm[];
    return myForm;
};

export const getDashboardFatigueAssessments = async (form: DashboardQueryModel) => {
    const assessments = await httpPost<FatigueAssessmentForm[]>(dashboardFatigueAssessmentsUri.toString(), form)
        .catch((e) => {
            console.log(e);
        }) as FatigueAssessmentForm[];
    return assessments;
};

export const submitFatigueAssessment = async (form: SubmitAssessmentModelBase) => {
    return await httpPost<number>(`${fatigueAssessmentSubmitFa}`, form)
        .catch(e => { console.log(e); return -1 });
};

export const submitOnBehalfAssessment = async (form: SubmitOnBehalfModel) => {
    return await httpPost<number>(`${fatigueAssessmentSubmitOnBehalf}`, form)
        .catch(e => { console.log(e); return -1 });
};

export const fatigueAssessmentAddNote = async (note: FatigueAssessmentAddNoteModel) => {
    const result = await httpPost<FatigueAssessmentNote[]>(`${fatigueAssessmentsAddNoteUri}`, note)
        .catch(e => { console.log(e); return null });
    return result;
};

export const saveAction = async (action: SubmitActionModel) => {
    const result = await httpPost<number>(`${fatigueAssessmentSaveActionUri}`, action)
        .catch(e => { console.log(e); return null });
    return result;
};

export const assign = async (faAssign: FatigueAssessmentAssign) => {
    const result = await httpPost<FatigueAssessmentAssignResult>(`${fatigueAssessmentAssignUri}`, faAssign)
        .catch(e => { console.log(e); return null });
    return result;
};
